import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";

const LOGO = "/mld-logo.png";

const links = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/workshops", label: "Workshops" },
  { to: "/gallery", label: "Gallery" },
  { to: "/parties", label: "Parties" },
  { to: "/#reviews", label: "Reviews" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header data-testid="site-navbar" className="fixed top-0 inset-x-0 z-50 bg-ink/85 backdrop-blur-md border-b-2 border-white/10">
      <div className="container-x flex items-center justify-between h-20">
        <Link to="/" data-testid="brand-link" className="flex items-center gap-3 group">
          <span className="relative w-11 h-11 flex-shrink-0">
            <span className="absolute inset-0 bg-rose blur-md opacity-40 group-hover:opacity-70 transition-opacity rounded-full" />
            <img
              src={LOGO}
              alt="MLD logo"
              className="relative w-11 h-11 object-contain group-hover:scale-110 transition-transform"
            />
          </span>
          <div className="flex items-baseline gap-2">
            <span className="font-display text-2xl md:text-3xl tracking-tight text-white group-hover:text-rose transition-colors">MISS LOLLY</span>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-5 xl:gap-7">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) => `nav-link ${isActive ? "text-rose" : ""}`}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:block">
          <Link to="/workshops" data-testid="nav-book-btn" className="btn-accent text-xs">
            Book a workshop
          </Link>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen(!open)}
          className="lg:hidden p-2 -mr-2 text-white border-2 border-white"
          aria-label="Menu"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-ink border-t-2 border-white/10">
          <div className="container-x py-6 flex flex-col gap-5">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                className="font-display text-2xl uppercase text-white hover:text-rose"
              >
                {l.label}
              </NavLink>
            ))}
            <Link to="/workshops" onClick={() => setOpen(false)} className="btn-accent text-xs w-fit">
              Book a workshop
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
